import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';

import { Input, Autocomplete, Select } from '~/components/Form';

import { isUndefined, isNull } from 'lodash';

import {
  Typography,
} from '@material-ui/core';

import {
  storeCadastroPosto,
  updateCadastroPosto,
} from '~/store/modules/cadastroposto/actions';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';

import { t, validCharacters } from '~/helpers';

import { Container } from './styles';

import { closeDialog } from '~/store/modules/dialog/actions';

export default function CreateOrUpdate({ reference, data, create }) {

  //const inputUnidadeRef = useRef();

  const dispatch = useDispatch();

  const [valueOrgao, setValueOrgao] = React.useState(0);

  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState(0);

  const [valueMunicipio, setValueMunicipio] = React.useState(0);


  const [inputValueUnidade, setInputValueUnidade] = React.useState('');

  const [fecharForm, setFecharForm] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { loading, find, params } = useSelector(
    (state) => state.cadastroposto
  );
  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {

    try {


      const schema = Yup.object().shape({
        poco_codigo: create
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
            .test(
              'characters-invalid',
              t('s.configuracao.geral.naopodecontercaracterespecial'),
              function (value) {
                return validCharacters(value);
              }
            )
          : Yup.string(),

        poco_descricao: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),

        poco_desc_abrev: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),

        poco_codigo_aux: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),

        poco_endereco: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
        ,

        poco_cep: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .max(99999999, t('s.geral.validacao.tamanhomaximo').replace('%s', 8)),

        orga_codigo: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          .min(2, t('s.geral.validacao.campoobrigatorio').replace('%s', 2))
          .nullable()
        ,
        unid_codigo: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
          .min(2, t('s.geral.validacao.campoobrigatorio').replace('%s', 2))

        ,
        muni_codigo: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          .min(2, t('s.geral.validacao.campoobrigatorio').replace('%s', 2))
          .nullable()
        ,

        poco_percentual_dif_turno: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100)),

        poco_status: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .nullable()
        ,

        poco_recebe_transf: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_le_temp_bico: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_controla_tanque: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_turno_terminal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_recebimento_terminal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_interface_siad: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_contr_int_siad: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_interface_stock300_liberado: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_recebimento_fracionado: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        poco_tem_telemetria: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),




      });

      await schema.validate({ ...param, unid_codigo: valueUnidade }, {
        abortEarly: false,
      });


      const objSend = {
        poco_codigo: param.poco_codigo,
        poco_descricao: param.poco_descricao,
        poco_desc_abrev: param.poco_desc_abrev,
        poco_codigo_aux: param.poco_codigo_aux,
        poco_endereco: param.poco_endereco,
        poco_cep: param.poco_cep,
        muni_codigo: param.muni_codigo,
        poco_recebe_transf: param.poco_recebe_transf,
        poco_le_temp_bico: param.poco_le_temp_bico,
        poco_controla_tanque: param.poco_controla_tanque,
        poco_status: param.poco_status,
        orga_codigo: param.orga_codigo,
        unid_codigo: param.unid_codigo,
        poco_percentual_dif_turno: param.poco_percentual_dif_turno,
        poco_turno_terminal: param.poco_turno_terminal,
        poco_recebimento_terminal: param.poco_recebimento_terminal,
        poco_interface_siad: param.poco_interface_siad,
        //cosi_consul_libera_abast_siad :  param.cosi_consul_libera_abast_siad,
        poco_contr_int_siad: param.poco_contr_int_siad,
        poco_recebimento_fracionado: param.poco_recebimento_fracionado,

        poco_ip_console_sonda: !isUndefined(param.poco_ip_console_sonda) ? param.poco_ip_console_sonda : null,
        poco_porta_console_sonda: !isUndefined(param.poco_porta_console_sonda) ? param.poco_porta_console_sonda : null,

        poco_tem_telemetria: param.poco_tem_telemetria,
        poco_interface_stock300_liberado: param.poco_interface_stock300_liberado,
      };

      if (create) {
        await dispatch(storeCadastroPosto(objSend, params));
      } else {
        await dispatch(updateCadastroPosto(objSend, params));
      }


    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {
        if (create) {
          setInputValueUnidade('');
          setValueUnidade(0);
          setValueOrgao(0);
        } else {
          setInputValueUnidade(find.unid_codigo);
          setValueUnidade(find.unid_codigo);
          setValueOrgao(find.orga_codigo);
        }
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);


  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {
        reference.current.setData(initials);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [loading]);

  const statusSimNao = [
    { label: 'Não', value: 'N', },
    { label: 'Sim', value: 'S', },
  ];

  const handleSetValue = useCallback((field, value) => {
    reference.current.setFieldValue(field, value);
  }, []);


  useEffect(() => {
    setValueUnidade(0);
    setInputValueUnidade('');
  }, [valueOrgao])



  return (
    <Container>

      {isLoading ?
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div> : ''
      }

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (<>
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="poco_codigo"
            label="Código"
            type="number"
            disabled={!create}
          />
          <Input
            name="poco_descricao"
            label="Descrição"
          />
          <Input
            name="poco_desc_abrev"
            label="Descrição Abreviada"
          />
          <Input
            name="poco_codigo_aux"
            label="Código Auxiliar"
          />
          <Input
            name="poco_endereco"
            label="Endereço"
          />

          <Autocomplete
            name="orga_codigo"
            label="orga_nome"
            title="Órgão"
            url="orgaos"
            unique="orga_codigo"
            hiddens={[{ name: 'orga_nome' }]}
            getValue={({ orga_codigo }) => {

              if (!isNull(orga_codigo)) {
                setValueOrgao(orga_codigo);
              } else {
                setValueOrgao(0);

              }
            }}
          />

          {/* <Autocomplete
            name="orga_codigo"
            label="orga_nome"
            title="Órgão"
            id="orga_codigo"
            url="orgaos"
            unique="orga_codigo"
            hiddens={[{ name: 'orga_nome' }]}
            value={valueOrgao}
            inputValue={inputValueOrgao}
            onChange={(event, newValue) => {
              setValueOrgao(newValue);
            }}
            onInputChange={(event, newInputValueOrgao) => {
              setInputValueOrgao(newInputValueOrgao);
            }}
            defaultValue=""
            getValue={(value) => {
              setValueUnidade(0);
              setInputValueUnidade('');
              reference.current.setFieldValue('unid_codigo', 0);
              reference.current.setFieldValue('orga_codigo', value.orga_codigo);
              if (value.orga_codigo !== null) {
                setValueOrgao(value.orga_codigo);
              } else {
                setValueOrgao('');
              }
            }}
          /> */}

          {/* <Autocomplete
            name="unid_codigo"
            label="unid_nome"
            title="Unidade"
            id="unida_codigo"
            url="unidades"
            disabled={valueOrgao === ''}
            unique="unid_codigo"
            hiddens={[{ name: 'unid_nome' }]}


            value={valueUnidade}
            inputValue={inputValueUnidade}
            onChange={(event, newValue) => {
              setValueUnidade(newValue);
            }}
            onInputChange={(event, newInputValueUnidade) => {
              setInputValueUnidade(newInputValueUnidade);
            }}


            defaultValue=""
            getValue={(value) => {
              reference.current.setFieldValue('unid_codigo', value.unid_codigo);
              if (value.unid_codigo !== null) {
                setValueUnidade(value.unid_codigo);
              } else {
                setValueUnidade(0);
              }
            }}
            params={{
              wherefield: 'orga_codigo',
              valuewherefield: valueOrgao || initials.orga_codigo,
              typewherefield: 'EQUALS',
            }}
          /> */}



          {(valueOrgao || initials.orga_codigo) ?
            <Autocomplete
              // id="idunid_codigo"
              autoHighlght
              name="unid_codigo"
              label="unid_nome"
              title="Unidade"
              url="unidades"
              disabled={valueOrgao === 0}
              unique="unid_codigo"
              inputValue={inputValueUnidade}
              onChange={(event, newValue) => {
                setValueUnidade(newValue);
              }}
              onInputChange={(event, newInputValueUnidade) => {
                if (valueOrgao) {
                  setInputValueUnidade(newInputValueUnidade);
                }
              }}
              getValue={({ unid_codigo }) => {
                setValueUnidade(unid_codigo)
              }}
              hiddens={[{ name: 'unid_nome' }]}
              params={{
                wherefield: 'orga_codigo',
                valuewherefield: valueOrgao || initials.orga_codigo,
                typewherefield: 'EQUALS',
              }}
              disableClearable={!inputValueUnidade}
            /> : ''
          }

          <Input
            name="poco_cep"
            label="CEP"
            type="number"
          />

          <Autocomplete
            name="muni_codigo"
            label="muni_nome"
            title="Município"
            id="unida_codigo"
            url="municipio"
            unique="muni_codigo"
            defaultValue=""
            hiddens={[{ name: 'muni_nome' }]}
            getValue={(value) => {
              if (value.muni_codigo !== null) {
                setValueMunicipio(value.muni_codigo);
              } else {
                setValueMunicipio(0);
              }
            }}
          />
          <Input
            name="poco_percentual_dif_turno"
            label="Dif. Máxima Turno"
            type="number"
          />

          <Select
            name="poco_recebe_transf"
            label='Recebe Transferência'
            options={statusSimNao}
          //defaultValue={initials.poco_recebe_transf || 'N'}
          />

          <Select
            name="poco_le_temp_bico"
            label='Lê Temperatura Bico'
            options={statusSimNao}
          //defaultValue={initials.poco_le_temp_bico || 'N'}
          />

          <Select
            name="poco_controla_tanque"
            label='Controla Tanques'
            options={statusSimNao}
          //defaultValue={initials.poco_controla_tanque || 'N'}
          />

          <Select
            name="poco_turno_terminal"
            label='Opera Turno no Terminal'
            options={statusSimNao}
          //defaultValue={initials.poco_turno_terminal || 'N'}
          />

          <Select
            name="poco_recebimento_terminal"
            label='Opera Recebimento no Terminal'
            options={statusSimNao}
          //defaultValue={initials.poco_recebimento_terminal || 'N'}
          />

          <Select
            name="poco_interface_siad"
            label='Opera Interface SAP'
            options={statusSimNao}
          //defaultValue={initials.poco_interface_siad || 'N'}
          />
          {/* <Select
            name="cosi_consul_libera_abast_siad"
            label='cosi_consul_libera_abast_siad'
            options={statusSimNao}
            defaultValue={initials.cosi_consul_libera_abast_siad || 'N'}
          /> */}
          <Select
            name="poco_contr_int_siad"
            label='Interface SAP. Habilitada'
            options={statusSimNao}
          //defaultValue={initials.poco_contr_int_siad || 'N'}
          />
          <Select
            name="poco_interface_stock300_liberado"
            label='Interface STOCK300 Liberado'
            options={statusSimNao}
          //defaultValue={initials.poco_interface_stock300_liberado || 'N'}
          />
          <Select
            name="poco_recebimento_fracionado"
            label='Recebimento Fracionado Habilitada'
            options={statusSimNao}
          //defaultValue={initials.poco_recebimento_fracionado || 'N'}
          />
          <Select
            name="poco_tem_telemetria"
            label='Tem Telemetria'
            options={statusSimNao}
          //defaultValue={initials.poco_tem_telemetria || 'N'}
          />
          <Input
            name="poco_ip_console_sonda"
            label="IP Console Sonda"
          /> <Input
            name="poco_porta_console_sonda"
            label="Porta Console Sonda"
          />




          <Select
            name="poco_status"
            variant="outlined"
            label="Status"
            options={[
              { value: 1, label: 'Liberado' },
              { value: 2, label: 'Bloqueado' },
              { value: 3, label: 'Cancelado' },
            ]}
          />

        </Form>
      </>
      )}


    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
